module.exports = __webpack_public_path__ + "img/icon_map_5.1445ac74.png";